import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ReferencesService } from 'src/app/services/references/references.service';
import moment from 'moment';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import { WarningModalContentComponent } from '../../lib/warning-modal/warning-modal.component';
import {PermissionsService} from "../../services/permissions/permissions.service";
import {ConstantsService} from "../../services/constants/constants.service";
import { ExportRefereeSettingsModalComponent } from '../reference-report-content/components/export-referee-settings-modal/export-referee-settings-modal.component';
import {PeopleService} from "../../services/people/people.service";
import {Router} from "@angular/router";
import {TrustMarketplaceStatusService} from "../../services/trust-marketplace-status/trust-marketplace-status.service";


@Component({
  selector: 'app-references',
  templateUrl: './references.component.pug',
  styleUrls: ['./references.component.scss'],
  standalone: false
})
export class ReferencesComponent implements OnInit, OnChanges {
  canViewReferenceTab: boolean = true;

  constructor(
    private modalService: BsModalService,
    private alertList: AlertBannerService,
    private referencesService: ReferencesService,
    public permissions: PermissionsService,
    private peopleService: PeopleService,
    private router: Router,
    private trustMarketplaceStatusService: TrustMarketplaceStatusService,
  ) { }

  @Input() searchOption: any = undefined;
  @Input() rowsPerPage = 20;
  @Input() pageNumber = 1;
  @Input() sortString = '-created';
  @Input() filterOptions: any;
  @Input() deleteorstopReferenceId: any;
  @Input() backgroundRefreshCounter: number = 0;

  @Output() viewReport: EventEmitter<any> = new EventEmitter();
  @Output() outputLoading = new EventEmitter();
  @Output() outputTotal = new EventEmitter();
  @Output() outputNoData = new EventEmitter();
  @Output() outputSortOptions = new EventEmitter();
  @Output() outputFilterStatusOptions = new EventEmitter();
  @Output() outputBackGroundSearchOptions = new EventEmitter();

  loading = true;
  total = 5;
  noData = false;
  initialDataRequest = true;
  references: any;
  exportModal: BsModalRef = new BsModalRef();
  hasBackgroundCheckPermissions = false;
  nameClicked = false;
  tmpAdminStatus: number | undefined = 1;

  sortOptions = [
    {
      'label':$localize`Requested date`,
      'type': "number",
      'value':"created"
    },
    {
      'label':$localize`Candidate`,
      'type': "word",
      'value':"candidate_name"
    }
  ];

  filterStatusOptions = [
    {'label': $localize`Requested`, 'value': 'Requested'},
    {'label': $localize`In progress`, 'value': 'In progress'},
    {'label': $localize`Completed`, 'value': 'Completed'},
    {'label': $localize`Stopped`, 'value': 'Stopped'},
    {'label': $localize`Expired`, 'value': 'Expired'}
  ];
  sendDateLabel = $localize`Send date`;
  userPermissions;
  deleteRequestWarningModal: BsModalRef = new BsModalRef();
  internalRefLabel = $localize`Internal reference`;
  ENT_INTERNAL_REF_FF_5437 = false;
  ENT_9003_FE_REQUESTS_PERSISTENT_DATA = false;

  ngOnInit(): void {
    // while removing this ff flag, please update the value in variable initialization to remove deprecated code
    this.ENT_INTERNAL_REF_FF_5437 = this.permissions.isFeatureActivated('ENT-9344-INTERNAL-REFERENCE-FF')
    this.ENT_9003_FE_REQUESTS_PERSISTENT_DATA = this.permissions.isFeatureActivated('ent-9003-fe-requests-persistent-data');

    window.scrollTo(0, 0);
    this.sortOptions[0] = {...this.sortOptions[0], label : $localize`Send date`}

    this.sortOptions.push({
      'label': $localize`View Status`,
      'type': "viewed",
      'value': "viewed"
    });

    this.fetchTrustMarketplaceStatus();
    this.fetchData();
    this.emitToParent();

    this.canViewReferenceTab = (this.permissions.hasPermission('can_view_reference_requests_list') || this.permissions.hasPermission('can_view_reference_requests_list_with_survey_perms') || this.permissions.hasPermission('can_view_own_reference_requests_list') || this.permissions.hasPermission('can_view_integrationuser_requests_list') || this.permissions.hasPermission('can_view_integrationuser_requests_list_restricted'));
    if(!this.canViewReferenceTab){
      this.loading = false;
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Background refresh - silent refresh without loading indicator
    if (this.ENT_9003_FE_REQUESTS_PERSISTENT_DATA && (changes.backgroundRefreshCounter && !changes.backgroundRefreshCounter.firstChange)) {
      this.fetchData(true);
      return;
    }

    this.loading = true;
    if (!this.initialDataRequest &&
      (changes.searchOption || changes.rowsPerPage || changes.pageNumber || changes.sortString || changes.filterOptions || changes.deleteorstopReferenceId)) {
        this.fetchData();
        this.emitToParent();
    }
  }

  fetchData(silent: boolean = false) {
    // GET all states if this.filterOptions['statusOption'] is empty
    let localFilterOptions = this.filterOptions ? { ...this.filterOptions } : { filter: 'All' };
    if (!localFilterOptions?.['statusOption']?.length) {
      localFilterOptions['statusOption'] = Object.keys(this.referencesService.statusMap)
    }
    this.initialDataRequest = this.areDefaultValues(localFilterOptions)

    if (this.filterOptions?.unread_only) {
      localFilterOptions['unread_only'] = true;
    }

    // Couldn't find a more viable method to replace default sort option on app-references initialise. Best I could find for the moment
    if(this.sortString.includes('name')) { this.sortString = this.sortString.replace('name', 'candidate_name'); }

    this.referencesService.getReferencesV1(
      this.searchOption,
      this.rowsPerPage,
      this.pageNumber,
      this.sortString,
      localFilterOptions,
    ).subscribe(
      response => {
        if(response['data']) {
          this.references = response['data'];
          this.references.forEach(check => {
            let ua = '';
            check.requested = moment.utc(check.requested).local().format('ll')
            check.xref.referees.forEach(referee => {
              if(referee.unusual_activity === 'confirmed' || referee.unusual_activity === 'detected' && ua === '') {
                ua = referee.unusual_activity;
              }
            })
            check.unusual_activity = ua;
          })

          this.getUserPermissions();
          this.total = response['pages']['total'] * this.rowsPerPage;
          this.emitToParent();
          // if first/initial data request returns no data, means the page has no data at all, so show
          // noData image, don't show in any other circumstance eg. searches etc.
          if (this.total < 1 && this.initialDataRequest) {
            this.noData = true;
            this.emitToParent();
          } else {
            this.convertData();
            this.initialDataRequest = false;
          }
          this.loading = false;
          this.emitToParent();
        } else {
          this.initialDataRequest = false;
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
          this.loading = false;
          this.emitToParent();
        }
      },
      error => {
        this.initialDataRequest = false;
        if (error.status != 403) {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
        this.loading = false;
        this.emitToParent();
      },
    );
  }

  emitToParent() {
    this.outputLoading.emit(this.loading);
    this.outputTotal.emit(this.total);
    this.outputNoData.emit(this.noData);
    this.outputSortOptions.emit(this.sortOptions);
    this.outputFilterStatusOptions.emit(this.filterStatusOptions);
  }

  convertData() {
    this.references.forEach(reference => {
      if (reference.requested) {
        const date = moment(reference.requested);
        if (date.isValid()) reference.requested = date.format('ll');
      }
      if (reference.candidate) {
        reference.candidate.initials = reference.candidate.first_name[0] + reference.candidate.last_name[0];
      }

      // Set status colour based on raw state value
      this.setStatusColour(reference);

      reference.xref.state = reference.xref.state.replace(/_/g, ' ');
      reference.xref.state = reference.xref.state.charAt(0).toUpperCase() + reference.xref.state.slice(1);
      reference.xref.state = this.filterStatusOptions.find(obj => obj.value === reference?.xref.state)?.label;
      reference.actionButtonData = this.populateActionButton(reference);
    });
  }

  setStatusColour(reference) {
    let state = reference.xref.state.toLowerCase();
    if (state === 'completed') {
      reference.status_colour = 'green';
    }
    else if (state === 'in_progress') {
      reference.status_colour = 'yellow';
    }
    else if (state === 'stopped' || state === 'expired') {
      reference.status_colour = 'red';
    }
    else if (state === 'requested') {
      reference.status_colour = 'grey';
    }
  }

  onViewReport(id) {
    this.viewReport.emit(id);
  }

  getUserPermissions(){
    this.references.forEach(reference => {
      reference.deleteperm = this.permissions.hasUserPermissionCancel(reference);
    })
  }

  deleteorstopRequest(request) {
    let initialState = {
      'title': $localize`Delete request?`,
      'message': $localize`Are you sure you want to delete the request for ${request?.candidate.first_name} ${request?.candidate.last_name}`
    }
    if (request.xref.state == this.filterStatusOptions.find(obj => obj.value === "In progress")?.label) {
      initialState = {
        'title': $localize`Stop request?`,
        'message': $localize`Are you sure you want to stop the request for ${request?.candidate.first_name} ${request?.candidate.last_name}`
      }
    }
    this.deleteRequestWarningModal = this.modalService.show(WarningModalContentComponent,
      { class: 'modal-dialog-centered default-modal', initialState }
    );

    this.deleteRequestWarningModal.content.closeBtnName = 'Close';
    this.deleteRequestWarningModal.content.selection.subscribe(deleteBtnClicked => {
      if (deleteBtnClicked) {
        this.referencesService.deleteorstopCheck(request.id).subscribe(
          (res) => {
            if (res['data']['deleted']) {
              this.referencesService.clearCache(); // Clear cache on successful action
              if (request.xref.state == this.filterStatusOptions.find((obj) => obj.value === 'In progress')?.label) {
                this.fetchData();
                this.alertList.append([{
                  type: AlertType.SUCCESS,
                  message: $localize`Success! The request has been stopped.`,
                  keepOnRouteChange: true
                }])
              }
                else if (request.xref.state == this.filterStatusOptions.find(obj => obj.value === "Requested")?.label){
                  this.references = this.references.filter(reference_request => { return reference_request.id !== request.id })
                  this.alertList.append([{
                    type: AlertType.SUCCESS,
                    message: $localize`Success! The request has been stopped.`,
                    keepOnRouteChange: true,
                  },
                ]);
              } else if (
                request.xref.state == this.filterStatusOptions.find((obj) => obj.value === 'Requested')?.label
              ) {
                this.referencesService.clearCache(); // Clear cache on successful action
                this.references = this.references.filter((reference_request) => {
                  return reference_request.id !== request.id;
                });
                this.alertList.append([
                  {
                    type: AlertType.SUCCESS,
                    message: $localize`Success! The request has been deleted.`,
                    keepOnRouteChange: true,
                  },
                ]);
              } else if (request.xref.state == 'Requested') {
                this.referencesService.clearCache(); // Clear cache on successful action
                this.references = this.references.filter((reference_request) => {
                  return reference_request.id !== request.id;
                });
                this.alertList.append([
                  {
                    type: AlertType.SUCCESS,
                    message: $localize`Success! The request has been deleted.`,
                    keepOnRouteChange: true
                  }])
                }
            }
          }, error => {
            console.log(error);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`This request has been started by the recipient and can no longer be deleted.`,
              keepOnRouteChange: true
            }]);
          })
      }
    });
  }

  isDeleteRequestVisible(reference):boolean {
    return !!(reference.xref.state == this.filterStatusOptions.find(obj => obj.value === "Requested")?.label && reference?.deleteperm);
  }

  isAddBackgroundCheckVisible(reference):boolean {
    let state = reference.xref.state;

    if (this.userHasBackgroundCheckPermissionOnRequest(reference)) {
      return (state == this.filterStatusOptions.find(obj => obj.value === "Requested")?.label ||
              state == this.filterStatusOptions.find(obj => obj.value === "In progress")?.label) && this.hasBackgroundCheckPermissions;
    }


    if (this.permissions.hasPermission('send_request')) {
      return (state == this.filterStatusOptions.find(obj => obj.value === "Requested")?.label ||
      state == this.filterStatusOptions.find(obj => obj.value === "In progress")?.label) && this.hasBackgroundCheckPermissions;
    }
    return false;
  }

  backGroundCheckCandidateData(candidateData, request){
    return {
        first_name: candidateData.first_name,
        last_name: candidateData.last_name,
        email: candidateData.email,
        country_code: candidateData.phone.slice(0, 3),
        mobile_phone: candidateData.phone.slice(3),
        check_id : request.id,
        disable_replace: true
      }
  }
  AddBackgroundCheck(request) {
    let candidateData = { ...request.candidate }
    this.peopleService.selectedPeople = [this.backGroundCheckCandidateData(candidateData, request)]
    this.router.navigateByUrl('/request', { state: { checkType: 'background-check', preFill: true } });
  }

  isViewBackgroundCheckVisible(reference):boolean {
    return this.hasBackgroundCheckPermissions && (this.userHasBackgroundCheckPermissionOnRequest(reference) || this.permissions.hasPermission('can_manage_support_background_checks')) && reference?.additional_check;
  }

  private userHasBackgroundCheckPermissionOnRequest(reference) {
    // Check if user meets criteria to manage background check
    if (
      this.permissions.hasPermission('can_manage_backgroundcheck_requests') ||
      ((this.permissions.hasPermission('can_manage_backgroundcheck_requests_with_survey_perms') ||
        this.permissions.hasPermission('can_manage_own_backgroundcheck_requests')) && !reference.is_restricted
      ) ||
      this.permissions.hasPermission('can_add_backgroundcheck_to_integration_requests') && (reference.integration=='open' && reference.integration_sub!=='Xref Enterprise Platform'))
    {
      return true;
    }

    return false;
  }

  viewBackgroundCheck(request) {
    this.outputBackGroundSearchOptions.emit(
      {
        id:'backGroundCheck',
        recipientName: request.candidate.first_name + ' ' + request.candidate.last_name,
        startDate: moment(request.requested),
        endDate: moment()
      })
  }

  isStopRequestVisible(reference):boolean{
    return !!(reference.xref.state == this.filterStatusOptions.find(obj => obj.value === "In progress")?.label && reference?.deleteperm);
  }

  showExportReportButton(reference) {
    return this.referenceInAnsweredState(reference);
  }

  exportReport(reference) {
    let initialState = {"refereeDetails": reference.xref.referees, 'checkId': reference.id};
    this.exportModal = this.modalService.show(ExportRefereeSettingsModalComponent, {
      class: 'modal-lg modal-dialog-centered max-width-900', initialState
    });
  }

  showNoActionAvailable(reference) {
    let state = reference.xref.state;
    let refereeInAnsweredState = this.referenceInAnsweredState(reference);
    if (state!=this.filterStatusOptions.find(obj => obj.value === "Completed")?.label) {
      if ((state!=this.filterStatusOptions.find(obj => obj.value === "Requested")?.label && !refereeInAnsweredState && state!=this.filterStatusOptions.find(obj => obj.value === "In progress")?.label || !reference?.deleteperm)
        && !refereeInAnsweredState
        && (!this.isViewBackgroundCheckVisible(reference) &&
          !this.isAddBackgroundCheckVisible(reference))) return true;
      }
    else {
      if (!refereeInAnsweredState && (!this.isViewBackgroundCheckVisible(reference) && !this.isAddBackgroundCheckVisible(reference))) return true;
    }
    return false
    }

  /**
   * Returns True if Even one of the referee is in answered state
   * @param reference Reference Check
   * @returns Boolean
   */
  private referenceInAnsweredState(reference): boolean {
    let refereeInAnsweredState = false;
    reference.xref.referees.forEach(referee => {
      if (referee.status.toLowerCase() === 'answered') refereeInAnsweredState = true
    })
    return refereeInAnsweredState;
  }
  fetchTrustMarketplaceStatus() {
    this.trustMarketplaceStatusService.trustStatus$.subscribe(
      res => {
        this.hasBackgroundCheckPermissions = res === ConstantsService.TRUST_MARKET_PLACE_STATUSES.connected;
        this.populateBackgroundChecksActionButton();
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
    this.trustMarketplaceStatusService.trustAdminStatus.subscribe(
      res => {
        if (res != undefined) {
          this.tmpAdminStatus = res;
        }
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );

  }

  onClickRequestCard(event: any, request: any) {
  if (
    this.permissions.hasPermission('can_view_reference_requests_list') ||
    this.permissions.hasPermission('can_view_integrationuser_requests_list') ||
    (this.permissions.hasPermission('can_view_reference_requests_list_with_survey_perms') && !request?.is_restricted) ||
    (this.permissions.hasPermission('can_view_own_reference_requests_list') && !request?.is_restricted && request.user_own_request) ||
    (this.permissions.hasPermission('can_view_integrationuser_requests_list_restricted') && !request?.is_restricted && request.user_own_request)
  ) {
    this.onViewReport(request?.id);
  }

}

  onClickName(event: any, request) {
    this.referencesService.getLinkedPerson(request.id, request.candidate.email).subscribe(res=>{
      if (res.person_uid) {
        this.nameClicked = false;
        this.router.navigate([`/people/profile/${res.person_uid}`]);
      }
    });
  }

  populateBackgroundChecksActionButton() {
    this.references?.forEach(reference => {
      if (this.isViewBackgroundCheckVisible(reference) && reference.actionButtonData.find(obj => obj.key === "2") == null) {
        reference.actionButtonData = reference.actionButtonData.find(obj => obj.key === "0")? [] : reference.actionButtonData;
        reference.actionButtonData.unshift({key: '2', value: $localize`View background checks`});
      }
      if (this.isAddBackgroundCheckVisible(reference) && reference.actionButtonData.find(obj => obj.key === "1") == null) {
        reference.actionButtonData = reference.actionButtonData.find(obj => obj.key === "0")? [] : reference.actionButtonData;
        reference.actionButtonData.unshift({key: '1', value: $localize`Add background checks`});
      }
    });
  }

  populateActionButton(reference) {
    let choices = new Array<{ key: string; value: string; disabled?: boolean }>();
    if (this.isAddBackgroundCheckVisible(reference)) {
        choices.push({key: '1', value: $localize`Add background checks`})
      }
    if (this.isViewBackgroundCheckVisible(reference))
    {
      choices.push({key: '2', value: $localize`View background checks`})
    }
      if (this.isDeleteRequestVisible(reference)) {
        choices.push({key: '5', value: $localize`Delete request`, disabled: reference.is_restricted})
      }
      if (this.isStopRequestVisible(reference)) {
        choices.push({key: '6', value: $localize`Stop request`, disabled: reference.is_restricted})
      }
    if (this.showExportReportButton(reference))
    {
      choices.push({key: '7', value: $localize`Export reports`, disabled: reference.is_restricted})
    }
    if (this.showNoActionAvailable(reference))
    {
      choices.push({key: '0', value: $localize`No actions available`})
    }
    return choices;
  }

  handleKebabAction(event, reference) {
    switch (event.key)
    {
      case '1':
        this.AddBackgroundCheck(reference);
      break;
      case '2':
        this.viewBackgroundCheck(reference);
      break;
      case '3':
      case '4':
      case '5':
      case '6':
        this.deleteorstopRequest(reference);
      break;
      case '7':
        this.exportReport(reference);
      break;
    }
  }

  getRequestedByInfo(request){
    return {label: $localize`Requested by`, content: request?.requester.first_name + " " + request?.requester.last_name}

  }

  getSurveyInfo(request){
    return {label: $localize`Survey`, content: request?.xref?.criterion?.name}
  }


  getStatusInformation(request)
  {
    let original_status = this.getOriginalStatus(request);
    return {
      hasTag: true,
      nestedStatTagText: '',
      tagText: request.xref.state,
      status: original_status,
      tagCompleted: 0,
      tagTotal: 0,
      pulseCutoffIncomplete: false,
      cancelledBy: ''
    }
  }

  getOriginalStatus(request)
  {
    let original_status = '';
    this.filterStatusOptions.forEach( (status) => {
      if (status.label === request.xref.state)
      {
        original_status = status.value;
      }
    });
    return original_status;
  }

  areDefaultValues(localFilterOptions) {
    const isSearchOptionDefault = this.searchOption?.length === 0;
    const isRowsPerPageDefault = this.rowsPerPage === 20
    const isPageNumberDefault = this.pageNumber === 1
    const isSortStringDefault = this.sortString === '-created'
    const isFilterDefault = localFilterOptions.filter === "All"
    const isStatusOptionDefault = JSON.stringify(localFilterOptions.statusOption) === '["Requested","Deleted","In progress","Expired","Completed","Stopped"]'
    return isSearchOptionDefault && isRowsPerPageDefault && isPageNumberDefault && isSortStringDefault && isFilterDefault && isStatusOptionDefault
  }

    isRequestViewed(request: any) {
      const requestState = request.xref?.state?.toLowerCase();
      if (requestState !== 'completed' && requestState !== 'in_progress' && requestState !== "in progress") {
          return false;
      }

      const submittedReferees = request.xref.referees.filter((referee: any) =>
          referee.status?.toLowerCase() === 'answered'
      );

      return submittedReferees.length > 0 && submittedReferees.some((referee: any) => referee.viewed === false);
  }
}
